import React, { useState } from "react";
import { InputType } from "../../Utils/Utils";
import { SvgImages } from "../../Utils/LocalImages";
import Image from "./Image";

function CustomTextField({
  name,
  register,
  labelTitle,
  placeholder,
  inputType,
  additionalClasses,
  showError,
  errorMessage,
  showMandatory = false,
  ...props
}) {

  const [useType, setUseType] = useState(inputType);
  const [focus, setFocus] = useState(false);

  const handleInputFocus = () => {
    setFocus(true);
  };

  const handleInputBlur = () => {
    setFocus(false);
  };

  return (
    <div className="form-group d-flex flex-column">
      <h3 className="fw-600 medium-text mb-0">
        {labelTitle}{showMandatory ? <span className="danger">*</span> : null}
      </h3>
      <div className="d-flex flex-column">
        <div className="d-flex gap-2 mt-1">
          <input
            type={useType}
            className={`w-100 medium-text fw-400 custom-form-input ${additionalClasses ? additionalClasses : ""} ${inputType == InputType.password ? "pe-5" : ""}`}
            placeholder={placeholder}
            {...props}
            {...(register ? register(name) : {})} // Register only if provided
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
          />
          {inputType == InputType.password ? (
            <Image className="eye_icon2 cursor-pointer" src={useType != InputType.password ? SvgImages.password_show : SvgImages.password_hide} onClick={() => {
              setUseType(useType == InputType.password ? InputType.text : InputType.password)
            }} />
          ) : null}
        </div>
        <div className={focus ? "form-input-bottom-line-focused" : "form-input-bottom-line"} />
      </div>
      {showError ? <span className="danger small-text fw-400 mt-2">{errorMessage}</span> : null}
    </div>
  );
}

export default CustomTextField;
